import { createContext, useState } from "react";

export const PasswordProtectionContext = createContext();

const PasswordProtectionContextProvider = ({ children }) => {
    const [isPasswordCorrect, setIsPasswordCorrect] = useState(false);
    const [passwordError, setPasswordError] = useState(false);

    const checkPassword = (password) => {
        if (`${password}` === process.env.REACT_APP_PASSWORD) {
            setIsPasswordCorrect(true);

            return;
        }

        setPasswordError(true);

        setTimeout(() => {
            setPasswordError(false);
        }, 3000);
    };

    return (
        <PasswordProtectionContext.Provider value={{ isPasswordCorrect, passwordError, checkPassword }}>
            {children}
        </PasswordProtectionContext.Provider>
    );
};

export default PasswordProtectionContextProvider;
